<script setup lang="ts">
import RoomieIcon from '@lahaus-roomie/roomie/src/components/RoomieIcon/index.vue'
import VerifiedIcon from '@lahaus-roomie/roomie/src/assets/icons/v2/verified.svg'
import LaHausVerifiedLogo from '@lahaus-roomie/roomie/src/assets/icons/v2/la-haus-verificado-logo.svg'

const { t, rt, tm } = useI18n()

const cardsList: {title: string; description: string}[] = tm('cards')

</script>

<script lang="ts">
export default {
  name: 'WhoWeAreLaHausVerified'
}
</script>

<template>
  <div class="who-we-are-la-haus-verified-section">
    <div class="max-w-screen-lg mx-auto">
      <div class="who-we-are-la-haus-verified-section__header">
        <h3 class="flex gap-8 mb-lh-32 md:mb-lh-40">
          <span>
            <span class="display-6 md:display-4">
              {{ t('title.1') }}
            </span>

            <span class="display-regular-6 md:display-regular-4">
              {{ t('title.2') }}
            </span>
          </span>

          <RoomieIcon custom-styles="block w-16 h-16 md:w-30 md:h-30">
            <LaHausVerifiedLogo />
          </RoomieIcon>
        </h3>

        <p class="body-1-sb md:display-6">
          {{ t('description') }}
        </p>
      </div>

      <div class="who-we-are-la-haus-verified-section__grid">
        <div
          v-for="(card, index) in cardsList"
          :key="`${card.title}-${index}`"
          class="who-we-are-la-haus-verified-section__card">
          <div class="who-we-are-la-haus-verified-section__card-content">
            <div class="flex flex-col items-center gap-8">
              <div class="who-we-are-la-haus-verified-section__icon self-start">
                <RoomieIcon custom-styles="block w-32 h-32 md:w-48 md:h-48 text-spring-600">
                  <VerifiedIcon />
                </RoomieIcon>
              </div>

              <h3 class="hl-3-sb lg:display-6 display-7">
                {{ rt(card.title) }}
              </h3>
            </div>

            <div>
              <p class="lg:hl-3-m body-1-m">
                {{ rt(card.description) }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style src="./_index.scss" lang="scss"></style>

<i18n src="./i18n.json"></i18n>
